export default __webpack_public_path__ + "assets/images/a1a2564e29783ead1eedd55b6ba52114.png";